import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetCleanFee {
  house_ids: string;
}

interface IGetCurrencyTypeList {
  for_filter: number;
}

interface ICreatetask {
  type: number;
  house_id?: number;
  schedule_staff_id?: number;
  expected_date: string;
  expected_time: string;
  level?: number;
  currency_type: string;
  fee: number;
  note?: string;
  gen_transaction?: number;
  payment_method: number;
  photos?: string;
}

interface IUpdateTask {
  id: number;
  expected_date: string;
  expected_time: string;
  level: number;
  currency_type: string;
  fee: number;
  note?: string;
  status?: number;
  photos?: string;
  house_id?: number;
  schedule_staff_id?: number;
  gen_transaction?: number;
}

interface IGetStaffDetail {
  id: number;
}

const GET_CURRENCY_TYPE_LIST_API = '/api/schedule/currency_type/list';
const GET_CLEANING_FEE_LIST_API = '/api/schedule/cleaning_fee/list';
const GET_ALL_STAFF_API = '/api/schedule/staff/all';
const CREATE_TASK_API = '/api/schedule/task/create';
const UPDATE_TASK_API = '/api/schedule/task/update';
const GET_SETTINGS_API = '/api/house_status_setting/get';
const GET_STAFF_DETAIL_API = '/api/schedule/staff/detail';

@Injectable({
  providedIn: 'root',
})
export class CreateTaskService {
  constructor(private http: HttpClient) {}

  /** 获取保洁费用 */
  getCleanFee(params: IGetCleanFee) {
    const query = new HttpParams().append('house_ids', `${params.house_ids}`);
    return this.http.get(GET_CLEANING_FEE_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 币种列表 */
  getCleaningFeeCurrencyList(params: IGetCurrencyTypeList) {
    const query = new HttpParams().append('for_filter', `${params.for_filter}`);
    return this.http.get(GET_CURRENCY_TYPE_LIST_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 全部员工、分配人列表 */
  getAllStaff() {
    const query = new HttpParams();
    return this.http.get(GET_ALL_STAFF_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 创建任务 */
  createTask(params: ICreatetask) {
    return this.http.post(CREATE_TASK_API, params) as Observable<IHttpResponse>;
  }

  /** 更新任务 */
  updateTask(params: IUpdateTask) {
    return this.http.post(UPDATE_TASK_API, params) as Observable<IHttpResponse>;
  }

  /** 获取房态配置 */
  getSettings() {
    const query = new HttpParams();
    return this.http.get(GET_SETTINGS_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }

  /** 获取员工详情 */
  getStaffDetaik(params: IGetStaffDetail) {
    const query = new HttpParams().append('id', `${params.id}`);
    return this.http.get(GET_STAFF_DETAIL_API, {
      params: query,
    }) as Observable<IHttpResponse>;
  }
}
